import { gql } from "@apollo/client";

// LIST APIS

export const ROLES_LOV = gql`
  query Query {
    listRole {
      id
      name
      createdAt
    }
  }
`;

export const STORE_LOV = gql`
  query ListStore {
    listStore {
      id
      name
      is_active
    }
  }
`;

export const GENERAL_LOV = gql`
  query Query {
    listEnum
  }
`;

export const USERS_LOV = gql`
  query Query($role: [RoleList!]!) {
    listUserByRole(role: $role) {
      id
      full_name
    }
  }
`;

// END LIST APIS

export const GET_BRANDS = gql`
  query Query($input: AllBrandInput!) {
    allBrand(input: $input) {
      total
      nextPage
      data {
        id
        name
        image
        is_active
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_CATEGORY = gql`
  query AllCategory($input: AllCategoryInput!) {
    allCategory(input: $input) {
      total
      nextPage
      data {
        id
        name
        description
        icon
        parent_id
        path
        is_active
        store {
          id
          name
          owner {
            id
            full_name
            email
            image
            phone
            fcm_token
            is_active
            is_verified
            createdAt
            updatedAt
          }
          is_active
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_SUPPLIER = gql`
  query Query($input: UserByRoleInput!) {
    allUserByRole(input: $input) {
      total
      nextPage
      data {
        id
        full_name
        email
        image
        phone
        is_active
        is_verified
        createdAt
        updatedAt
        role {
          id
          name
          createdAt
        }
      }
    }
  }
`;

export const GET_CUSTOMERS = gql`
  query AllCustomer($input: AllCustomerInput) {
    allCustomer(input: $input) {
      data {
        user {
          full_name
          createdAt
          email
          fcm_token
          id
          image
          is_active
          is_verified
          phone
          role {
            id
            name
            createdAt
          }
          updatedAt
        }
        balance
        email
        business {
          address
          ein_number
          id
          license
          license_expiry
          license_no
          name
          type
        }
        createdAt
        full_name
        id
        phone
        updatedAt
        walk_in
      }
      nextPage
      total
    }
  }
`;

export const GET_PRODUCTS = gql`
  query AllProduct($input: AllProductInput) {
    allProduct(input: $input) {
      total
      nextPage
      data {
        id
        sku
        name
        description
        category {
          id
          name
          description
          icon
          parent_id
          path
          is_active
          createdAt
          updatedAt
        }
        brand {
          id
          name
          image
          is_active
          createdAt
        }
        unit {
          id
          name
        }
        images
        price
        off_type
        discount_value
        is_available
        stock {
          id
          warehouse {
            id
            name
            phone
            store_id
            address
            createdAt
            updatedAt
          }
          quantity
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const LIST_QUOTATION = gql`
  query Query($input: AllOrderInput!) {
    allOrder(input: $input) {
      total
      nextPage
      data {
        id
        customer {
          id
          full_name
          email
          phone
          business {
            id
            name
            type
            address
            license
            ein_number
            license_expiry
            license_no
          }
          createdAt
          updatedAt
        }
        store {
          id
          name
          owner {
            id
            full_name
            email
            image
            phone
            fcm_token
            is_active
            is_verified
            role {
              id
              name
              createdAt
            }
            createdAt
            updatedAt
          }
          image
          is_active
          createdAt
          updatedAt
        }
        warehouse {
          id
          name
          phone
          store_id
          address
          createdAt
          updatedAt
        }
        quotation_date
        user {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        status
        order_tax
        discount
        shipping
        total_amount
        description
        order_products {
          id
          product {
            id
            sku
            name
            description
            category {
              id
              name
              description
              icon
              parent_id
              path
              is_active
              store {
                id
                name
                owner {
                  id
                  full_name
                  email
                  image
                  phone
                  fcm_token
                  is_active
                  is_verified
                  role {
                    id
                    name
                    createdAt
                  }
                  createdAt
                  updatedAt
                }
                image
                is_active
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            brand {
              id
              name
              image
              is_active
              createdAt
              updatedAt
            }
            unit {
              id
              name
            }
            images
            price
            off_type
            discount_value
            is_available
            stock {
              id
              warehouse {
                id
                name
                phone
                store_id
                address
                createdAt
                updatedAt
              }
              quantity
            }
            createdAt
            updatedAt
          }
          quantity
          price
        }
      }
    }
  }
`;

export const LIST_WAREHOUSE = gql`
  query ListWarehouse($storeId: Int!) {
    listWarehouse(store_id: $storeId) {
      id
      name
      phone
      store_id
      address
      createdAt
      updatedAt
    }
  }
`;

export const LIST_BRANDS = gql`
  query Query($storeId: Int!) {
    listBrand(store_id: $storeId) {
      id
      name
      image
      is_active
      createdAt
      updatedAt
    }
  }
`;

export const LIST_CATEGORY = gql`
  query Query($storeId: Int!) {
    listCategories(store_id: $storeId) {
      id
      name
      description
      icon
      parent_id
      path
      is_active
      store {
        id
        name
        owner {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          createdAt
          updatedAt
        }
        is_active
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const PRODUCT_DETAIL = gql`
  query Query($productDetailId: Int!) {
    productDetail(id: $productDetailId) {
      id
      sku
      name
      description
      category {
        id
        name
        description
        icon
        parent_id
        path
        is_active
        store {
          id
          name
          owner {
            id
            full_name
            email
            image
            phone
            fcm_token
            is_active
            is_verified
            createdAt
            updatedAt
          }
          is_active
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      brand {
        id
        name
        image
        is_active
        createdAt
        updatedAt
      }
      unit {
        id
        name
      }
      images
      price
      off_type
      discount_value
      is_available
      stock {
        id
        warehouse {
          id
          name
          phone
          store_id
          address
          createdAt
          updatedAt
        }
        quantity
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_STORE = gql`
  query Query($input: AllStoreInput!) {
    allStore(input: $input) {
      total
      nextPage
      data {
        id
        name
        owner {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          createdAt
          updatedAt
        }
        is_active
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_UNITS = gql`
  query Query($input: AllUnitInput!) {
    allUnit(input: $input) {
      total
      nextPage
      data {
        id
        name
      }
    }
  }
`;

export const GET_WAREHOUSE = gql`
  query Query($input: AllWarehouseInput!) {
    allWarehouse(input: $input) {
      total
      nextPage
      data {
        id
        name
        phone
        store_id
        address
        createdAt
        updatedAt
      }
    }
  }
`;

export const LIST_UNITS = gql`
  query Query($storeId: Int!) {
    listUnit(store_id: $storeId) {
      id
      name
    }
  }
`;

export const LIST_CUSTOMER = gql`
  query ListCustomer($storeId: Int!) {
    listCustomer(store_id: $storeId) {
      id
      full_name
      email
      phone
      business {
        id
        name
        type
        address
        license
        ein_number
        license_expiry
        license_no
      }
      createdAt
      updatedAt
    }
  }
`;

export const LIST_PRODUCTS = gql`
  query ListProduct(
    $storeId: Int!
    $warehouseId: Int
    $customerId: Int
    $brandId: Int
  ) {
    listProduct(
      store_id: $storeId
      warehouse_id: $warehouseId
      customer_id: $customerId
      brand_id: $brandId
    ) {
      id
      name
      last_price
      images
      price
      off_type
      discount_value
      is_available
    }
  }
`;

export const GET_CATEGORY_BY_ID = gql`
  query GetCategory($getCategoryId: Int!) {
    getCategory(id: $getCategoryId) {
      id
      name
      description
      icon
      parent_id
      path
      is_active
      store {
        id
        name
        owner {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          createdAt
          updatedAt
        }
        is_active
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const LIST_STORE = gql`
  query AllStoreByAdmin($input: AllStoreInput!) {
    allStoreByAdmin(input: $input) {
      total
      nextPage
      data {
        id
        name
        owner {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        is_active
        createdAt
        updatedAt
      }
    }
  }
`;

export const CUSTOMER_DETAIL = gql`
  query Query($customerDetailId: Int!) {
    customerDetail(id: $customerDetailId) {
      id
      full_name
      email
      phone
      balance
      walk_in
      business {
        id
        name
        type
        address
        license
        ein_number
        license_expiry
        license_no
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_SALES = gql`
  query AllSales($input: AllOrderInput!) {
    allSales(input: $input) {
      total
      nextPage
      data {
        id
        reference_no
        customer {
          id
          full_name
          email
          phone
          business {
            id
            name
            type
            address
            license
            ein_number
            license_expiry
            license_no
          }
          createdAt
          updatedAt
        }
        invoice_no
        store {
          id
          name
          owner {
            id
            full_name
            email
            image
            phone
            fcm_token
            is_active
            is_verified
            role {
              id
              name
              createdAt
            }
            createdAt
            updatedAt
          }
          image
          is_active
          createdAt
          updatedAt
        }
        warehouse {
          id
          name
          phone
          store_id
          address
          createdAt
          updatedAt
        }
        sale_date
        order_id
        user {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        status
        sale_tax
        discount
        shipping
        paid
        due
        payment_status
        total_amount
        sale_items {
          id
          product {
            id
            sku
            name
            description
            category {
              id
              name
              description
              icon
              parent_id
              path
              is_active
              store {
                id
                name
                owner {
                  id
                  full_name
                  email
                  image
                  phone
                  fcm_token
                  is_active
                  is_verified
                  role {
                    id
                    name
                    createdAt
                  }
                  createdAt
                  updatedAt
                }
                image
                is_active
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            brand {
              id
              name
              image
              is_active
              createdAt
              updatedAt
            }
            unit {
              id
              name
            }
            images
            price
            off_type
            discount_value
            is_available
            stock {
              id
              warehouse {
                id
                name
                phone
                store_id
                address
                createdAt
                updatedAt
              }
              quantity
            }
            createdAt
            updatedAt
          }
          quantity
          price
        }
      }
    }
  }
`;

export const QUOTATION_DETAIL = gql`
  query Query($getOrderId: Int!) {
    getOrder(id: $getOrderId) {
      id
      customer {
        id
        full_name
        email
        phone
        business {
          id
          name
          type
          address
          license
          ein_number
          license_expiry
          license_no
        }
        createdAt
        updatedAt
      }
      store {
        id
        name
        owner {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        image
        is_active
        createdAt
        updatedAt
      }
      warehouse {
        id
        name
        phone
        store_id
        address
        createdAt
        updatedAt
      }
      quotation_date
      user {
        id
        full_name
        email
        image
        phone
        fcm_token
        is_active
        is_verified
        role {
          id
          name
          createdAt
        }
        createdAt
        updatedAt
      }
      status
      order_tax
      discount
      shipping
      total_amount
      description
      order_products {
        id
        product {
          id
          sku
          name
          description
          category {
            id
            name
            description
            icon
            parent_id
            path
            is_active
            store {
              id
              name
              owner {
                id
                full_name
                email
                image
                phone
                fcm_token
                is_active
                is_verified
                role {
                  id
                  name
                  createdAt
                }
                createdAt
                updatedAt
              }
              image
              is_active
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          brand {
            id
            name
            image
            is_active
            createdAt
            updatedAt
          }
          unit {
            id
            name
          }
          images
          price
          off_type
          discount_value
          is_available
          stock {
            id
            warehouse {
              id
              name
              phone
              store_id
              address
              createdAt
              updatedAt
            }
            quantity
          }
          createdAt
          updatedAt
        }
        quantity
        price
      }
    }
  }
`;

export const SALE_DETAIL = gql`
  query Query($getSaleId: Int!) {
    getSale(id: $getSaleId) {
      id
      invoice_no
      customer {
        id
        full_name
        email
        phone
        balance
        user {
          id
          full_name
          email
          image
          phone
        }
        business {
          id
          name
          type
          address
          license
          ein_number
          license_expiry
          license_no
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      store {
        id
        name
        image
        is_active
        createdAt
        updatedAt
      }
      warehouse {
        id
        name
        phone
        store_id
        address
        createdAt
        updatedAt
      }
      sale_date
      order_id
      user {
        id
        full_name
        email
        image
        phone
        fcm_token
        is_active
        is_verified
        createdAt
        updatedAt
      }
      status
      sale_tax
      discount
      shipping
      paid
      due
      payment_status
      total_amount
      sale_items {
        id
        product {
          id
          sku
          name
          description
          category {
            id
            name
            description
            icon
            parent_id
            path
            is_active
            createdAt
            updatedAt
          }
          brand {
            id
            name
            image
            is_active
            createdAt
            updatedAt
          }
          unit {
            id
            name
          }
          images
          price
          off_type
          discount_value
          is_available
          stock {
            id
            warehouse {
              id
              name
              phone
              store_id
              address
              createdAt
              updatedAt
            }
            quantity
          }
          createdAt
          updatedAt
        }
        quantity
        price
      }
      createdAt
      updatedAt
    }
  }
`;

export const SHOW_PAYMENT = gql`
  query AllPayments($input: AllPaymentInput) {
    allPayments(input: $input) {
      total
      nextPage
      data {
        id
        payment_date
        user {
          full_name
          id
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        customer {
          phone
          id
          full_name
          email
          balance
          business {
            id
            name
            type
            address
            license
            ein_number
            license_expiry
            license_no
          }
          createdAt
          updatedAt
        }
        received_amount
        is_reverted
        paying_type
        description
      }
    }
  }
`;

export const GET_DASHBOARD = gql`
 query Query($month: String!, $todayDate: String!, $year: String!, $storeId: Int!) {
  storeDashboard(month: $month, today_date: $todayDate, year: $year, store_id: $storeId) {
      yesterday_sale_amount
      current_month
      top_customers
      today_sale_count
      today_sale_amount
      total_sales_due
      total_sale_amount
      customers
      users
      sales_invoice
      recent_products {
        id
        sku
        name
        description
        category {
          id
          name
          description
          icon
          parent_id
          path
          is_active
          store {
            id
            name
            owner {
              id
              full_name
              email
              image
              phone
              fcm_token
              is_active
              is_verified
              role {
                id
                name
                createdAt
              }
              createdAt
              updatedAt
            }
            image
            is_active
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        brand {
          id
          name
          image
          is_active
          createdAt
          updatedAt
        }
        unit {
          id
          name
        }
        images
        price
        off_type
        discount_value
        is_available
        stock {
          id
          warehouse {
            id
            name
            phone
            store_id
            address
            createdAt
            updatedAt
          }
          quantity
        }
        createdAt
        updatedAt
      }
      sales {
        jan {
          purchase
          sales
        }
        feb {
          purchase
          sales
        }
        mar {
          purchase
          sales
        }
        apr {
          purchase
          sales
        }
        may {
          purchase
          sales
        }
        jun {
          purchase
          sales
        }
        jul {
          purchase
          sales
        }
        aug {
          purchase
          sales
        }
        sep {
          purchase
          sales
        }
        oct {
          purchase
          sales
        }
        nov {
          purchase
          sales
        }
        dec {
          purchase
          sales
        }
      }
    }
  }
`;

export const GET_CUSTOMER_REPORT = gql`
  query CustomerReport($input: AllCustomerInput!) {
    customerReport(input: $input) {
      data {
        id
        full_name
        email
        total_amount
        paid
        due
        payment_status
      }
      nextPage
      total
    }
  }
`;

export const LIST_USERS_BY_ROLE = gql`
  query ListUserByRole($role: [RoleList!]!) {
    listUserByRole(role: $role) {
      id
      full_name
      email
      image
      phone
      fcm_token
      is_active
      is_verified
      role {
        id
        name
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_SALES_RETURNS = gql`
  query GetSaleReturn($input: AllSaleReturnInput!) {
    allSaleReturns(input: $input) {
      nextPage
      total
      data {
        createdAt
        id
        reason
        return_date
        total_refund
      }
    }
  }
`;

export const LIST_SALES = gql`
  query ListSales($customerId: Int!, $invoiceNo: String) {
    listSales(customer_id: $customerId, invoice_no: $invoiceNo) {
      id
      customer {
        id
        full_name
        email
        phone
        balance
        user {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        business {
          id
          name
          type
          address
          license
          ein_number
          license_expiry
          license_no
          createdAt
          updatedAt
        }
        walk_in
        createdAt
        updatedAt
      }
      store {
        id
        name
        owner {
          id
          full_name
          email
          image
          phone
          fcm_token
          is_active
          is_verified
          role {
            id
            name
            createdAt
          }
          createdAt
          updatedAt
        }
        image
        is_active
        createdAt
        updatedAt
      }
      warehouse {
        id
        name
        phone
        store_id
        address
        createdAt
        updatedAt
      }
      sale_date
      invoice_no
      reference_no
      order_id
      user {
        id
        full_name
        email
        image
        phone
        fcm_token
        is_active
        is_verified
        role {
          id
          name
          createdAt
        }
        createdAt
        updatedAt
      }
      status
      sale_tax
      discount
      shipping
      paid
      due
      payment_status
      total_amount
      sale_items {
        id
        product {
          id
          sku
          name
          description
          category {
            id
            name
            description
            icon
            parent_id
            path
            is_active
            store {
              id
              name
              owner {
                id
                full_name
                email
                image
                phone
                fcm_token
                is_active
                is_verified
                role {
                  id
                  name
                  createdAt
                }
                createdAt
                updatedAt
              }
              image
              is_active
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          brand {
            id
            name
            image
            is_active
            createdAt
            updatedAt
          }
          unit {
            id
            name
          }
          created_by {
            id
            full_name
            email
            image
            phone
            fcm_token
            is_active
            is_verified
            role {
              id
              name
              createdAt
            }
            createdAt
            updatedAt
          }
          images
          price
          last_price
          off_type
          discount_value
          is_available
          stock {
            id
            warehouse {
              id
              name
              phone
              store_id
              address
              createdAt
              updatedAt
            }
            quantity
          }
          createdAt
          updatedAt
        }
        quantity
        price
      }
      createdAt
      updatedAt
    }
  }
`;
